Alpine.data('SevenReviewsAdd', (translations) => ({
    rating: 0,
    hoverRating: 0,
    ratings: [
        {'amount': 1, 'label': '😡 ' + translations.label1},
        {'amount': 2, 'label': '😕 ' + translations.label2},
        {'amount': 3, 'label': '😐 ' + translations.label3},
        {'amount': 4, 'label': '🙂 ' + translations.label4},
        {'amount': 5, 'label': '😄 ' + translations.label5}
    ],

    rate(rating) {
        this.rating = rating;
    },

    currentLabel() {
        const currentRating = this.ratings.find(ratingObj => ratingObj.amount === this.rating);

        return currentRating ? currentRating.label : '';
    }
}));